
import Vue from 'vue';
import store from '@/store';
import { State } from '@/common/interface';
import getActivityType from './getActivityType';

import Validate from '@/mixins/validate';
import VaidateCondition from '@/mixins/validateCondition';

const storeState: State = store.state;
const validateCondition = VaidateCondition();

export default function validForm(): string | void {
  const {
    title,                // 活动标题
    instName,             // 机构名称
    deadline,             // 活动截止时间
    startTime,            // 活动开始时间
    limitNum,             // 限制人数
    isLimited,            // 是否开启了限制
    documentTitle,        // 活动名称
  } = storeState;
  const validate = new Validate(validateCondition);
  validate.add(title.length, [{
    condition: 'isNonEmpty',
    errMsg: '请输入活动标题'
  }]);
  validate.add(title, [{
    condition: 'isEmoji',
    errMsg: '活动标题不支持表情'
  }])
  validate.add(instName, [{
    condition: 'isNonEmpty',
    errMsg: '请输入机构名称'
  }]);
  validate.add(deadline, [{
    condition: 'isNonEmpty',
    errMsg: '请输入活动截止时间'
  }, {
    condition: 'isDeadlineRight',
    errMsg: '截止时间必须大于当前时间'
    }]);
  startTime && validate.add(deadline - startTime, [{
    condition: 'isNonEmpty',
    errMsg: '请输入活动开始时间'
  }, {
      condition: 'isNonNegative',
    errMsg: '活动开始时间不能晚于截止时间'
    }]);

  validate.add(documentTitle, [{
    condition: 'isNonEmpty',
    errMsg: '活动名称不能为空'
  }]);

  getActivityType() === "bargainType" && validateBargainType(validate);
  getActivityType() === "groupType" && validateGroupType(validate);
  getActivityType() === 'solitaireType' && validataSolitaireType(validate);
  getActivityType() === 'gachaType' && validateGachaType(validate);
  getActivityType() === 'distributeType' && validateDistributeType(validate);
  getActivityType() === 'poseType' && validateAIEnroll(validate)
  return validate.result();
}

function validateDistributeType(validate: any) {
  const { distributeTypeParameter, section, activityTitle, activityIntros } = storeState;
  const { firstReward, secondReward, hasOpenSecondDistribute, hasCheckUserAgreement,hasSubtractLimitBuyerNum, courseDesc} = distributeTypeParameter;
  const { courseName, limitBuyerNum, courseOriginPrice, courseRushPrice } = section;

  validate.add(courseName, [{
    condition: 'isNonEmpty',
    errMsg: '课程名称不能为空'
  }]);

  if (courseDesc.length !== 0) {
    let htmlInnerText = "";
    courseDesc.map(item => {
      htmlInnerText += item.type === 'text' ? item.value : ""
    })
    htmlInnerText = htmlInnerText.replace(/<[^>]+>/g, "")
    // 手动输入富文本编辑器和直接粘贴检测课程描述长度
    if (htmlInnerText.length > 1000) {
      validate.add(courseDesc, [{
        condition: 'isAlert',
        errMsg: '课程描述超过1000字'
      }
      ])
    }
  }

  if (!limitBuyerNum && limitBuyerNum !== 0) {
    validate.add(Number(limitBuyerNum), [{
      condition: 'isNonEmpty',
      errMsg: '购课人数限制不能为空'
    }])
  }
  validate.add(Number(limitBuyerNum), [{
    condition: 'isIntervalRight',
    max: 9999,
    min: 1,
    errMsg: '购课人数为【1-9999】的整数',
  }, {
    condition: 'isInteger',
    errMsg: `购课人数为必须为整数`
    }]);

  if (hasSubtractLimitBuyerNum) {
    validate.add(Number(limitBuyerNum), [
      {
        condition: 'isAlert',
        errMsg: '购课人数只能增加不能减少'
      }]);
  }

  if (!courseOriginPrice && courseOriginPrice !== 0) {
    validate.add(Number(courseOriginPrice), [{
      condition: 'isNonEmpty',
      errMsg: '课程日常价不能为空'
    }])
  }

    validate.add(Number(courseOriginPrice), [{
      condition: 'isIntervalRight',
      max: 9999.99,
      min: 1,
      errMsg: '课程日常价范围为【1-9999.99】',
      }, {
        condition: 'isRegRight',
        regExp: new RegExp("^([0-9]{1,4})(\\.[0-9]{1,2})?$"),
        errMsg:'课程日常价范围为【1-9999.99】'
      }
    ]);



  if (!courseRushPrice && courseRushPrice !== 0) {
    validate.add(Number(courseRushPrice), [{
      condition: 'isNonEmpty',
      errMsg: '抢购价不能为空'
    }])
  }
    validate.add(Number(courseRushPrice), [
      {
        condition: 'isRegRight',
        regExp: new RegExp('^([0-9]{1,4})?(\\.[0-9]{1,2})?$'),
        errMsg: '受微信风控限制<br>抢购价范围为【1-5000】'
      },
      {
        condition: 'isIntervalRight',
        max: 5000,
        min: 1,
        errMsg: '受微信风控限制<br>抢购价范围为【1-5000】'
      },
      {
        condition: 'isEqualLimit',
        limit: Number(courseOriginPrice),
        errMsg: '抢购价必须低于日常价'
      }
    ]);

  if (!firstReward && firstReward !== 0) {
    validate.add(Number(firstReward), [{
      condition: 'isNonEmpty',
      errMsg: '一级分销佣金不能为空'
    }])
  }
    validate.add(Number(firstReward), [ {
      condition: 'isRegRight',
      regExp: new RegExp("^([0-9]*)(\\.[0-9]{1,3})?$"),
      errMsg:'一级分销佣金范围为【1-1000】,保留两位小数'
    },{
      condition: 'isIntervalRight',
      max: 1000,
      min: 1,
      errMsg: '一级分销佣金范围为【1-1000】',
      }]);

  // 若开启二级分销
  if (hasOpenSecondDistribute) {
    if (!secondReward && secondReward !== 0) {
      validate.add(Number(secondReward), [{
        condition: 'isNonEmpty',
        errMsg: '二级分销佣金不能为空'
      }])
    }
    if (Number(secondReward) >= Number(firstReward)) {
      validate.add(Number(secondReward), [{
        condition: 'isAlert',
        errMsg: `二级分销佣金必须小于一级分销佣金`
      }]);
    }
    validate.add(Number(secondReward), [{
      condition: 'isRegRight',
      regExp: new RegExp("^([0-9]*)(\\.[0-9]{1,2})?$"),
      errMsg:'二级分销佣金范围为【1-1000】,保留两位小数'
    },{
      condition: 'isIntervalRight',
      max: 1000,
      min: 1,
      errMsg: '二级分销佣金范围为【1-1000】',
    }]);
  }

  if (Number(firstReward)+Number(secondReward || 0) > Number(courseRushPrice) * 0.9) {
    validate.add(Number(secondReward), [
      {
        condition: 'isAlert',
        errMsg: '一级+二级分销可获佣金总和不可超过课程抢购价90%'
      }]);
  }

  validate.add(activityIntros, [
    {
      condition: 'isNonEmpty',
      errMsg: '活动说明不能为空'
    }
  ]);

  validate.add(hasCheckUserAgreement, [{
    condition: 'isNonEmpty',
    errMsg: '请先阅读并同意用户协议&免责声明'
  }]);
}

function validateGachaType(validate: any) {
  const { gachaTypeParameter,section } = storeState;
  const { scholarship, prize,gachaType,dayTimesChecked,totalTimesChecked,hasSubtractPrizeLength } = gachaTypeParameter;
  const { least, most, highest, } = scholarship;
  const { dayTimes, totalTimes } = section;
  const { proList, } = prize;

  if (gachaType === "scholarship") {
    if (String(least) === "") {
      validate.add(least, [{
        condition: 'isAlert',
        errMsg: '请输入每次抽奖最小值'
      }]);
    }
    validate.add(Number(least), [{
    condition: 'isIntervalRight',
    max: 99,
    min: 1,
    errMsg: '每次抽奖最小值请设置1~99元之间',
  }, {
    condition: 'isInteger',
    errMsg: `每次抽奖最小值必须为整数`
  }]);

  if (String(most) === "") {
    validate.add(most, [{
      condition: 'isAlert',
      errMsg: '请输入每次抽奖最大值'
    }]);
  }
  validate.add(Number(most), [ {
    condition: 'isIntervalRight',
    max: 99,
    min: 1,
    errMsg: '每次抽奖最大值请设置1~99元之间',
  }, {
    condition: 'isInteger',
    errMsg: `每次抽奖最大值必须为整数`
  }, {
    condition: 'minLimit',
    errMsg: '每次抽奖最大值必须大于最小值',
    limit: least
    }]);
    if (Number(least) === Number(most)) {
      validate.add(most, [{
        condition: 'isAlert',
        errMsg: '每次抽奖最大值必须大于最小值'
      }]);
    }

    if (String(highest)=== "") {
      validate.add(highest, [{
        condition: 'isAlert',
        errMsg: '请输入最高可得奖学金数'
      }]);
    }
  validate.add(Number(highest), [{
    condition: 'isIntervalRight',
    max: 9999,
    min: 1,
    errMsg: '最高奖学金数请设置1~9999元之间',
  }, {
    condition: 'isInteger',
    errMsg: `每次抽奖最大值必须为整数`
  }, {
    condition: 'minLimit',
    errMsg: '最高奖学金数不可低于每次抽奖最大值',
    limit: most
  }]);
  } else {
    validate.add(proList.length, [{
      condition: 'isNonEmpty',
      errMsg: '至少添加1个奖品'
    }]);
    for (let i = 0; i < proList.length; i++) {
      const { img, name, num, winningProbability } = proList[i];
      // 奖品名称不能重复
      let nameList: Array<string> = [];

      // 奖品中奖概率不能超过100%
      let probabilitySum = 0;

        proList.map((item: any) => {
          nameList.push(item.name);
          probabilitySum += Number(item.winningProbability);
          if (item.winningProbability < 0) {
            validate.add(item.winningProbability, [{
              condition: 'minLimit',
              errMsg: '奖品中奖概率不能为负数',
              limit: 0
              }]);
          }
        })

        validate.add(Number(num), [{
          condition: 'isInteger',
          errMsg: '奖品数量请设置1~9999之间的整数'
        }]);

      // 活动发布后修改过奖品数量
      if (hasSubtractPrizeLength) {
        validate.add(highest, [{
          condition: 'isAlert',
          errMsg: '活动发布后奖品数量只能增加不能减少'
        }]);
      }
      if (probabilitySum > 100) {
        validate.add(probabilitySum, [{
          condition: 'isAlert',
          errMsg: '奖品中奖概率的总和不可超过100%'
        }]);
      }


      if (nameList.lastIndexOf(name) !== i) {
        validate.add(img, [{
          condition: 'isAlert',
          errMsg: '奖品名称不可重复'
        }]);
      }
      validate.add(img, [{
        condition: 'isNonEmpty',
        errMsg: '请设置奖品图片'
      }]);
      validate.add(name, [{
        condition: 'isNonEmpty',
        errMsg: '请输入奖品名称'
      }]);

      validate.add(num, [{
        condition: 'isNonEmpty',
        errMsg: '请输入奖品数量'
      }, {
        condition: 'isIntervalRight',
        max: 9999,
        min: 1,
        errMsg: '奖品数量请设置1~9999之间',
      }]);
      validate.add(winningProbability, [{
        condition: 'isNonEmpty',
        errMsg: '请输入奖品中奖概率'
      }]);

    }
  }
  if (!totalTimesChecked && String(dayTimes) == "") {
    validate.add(dayTimes, [{
      condition: 'isAlert',
      errMsg: '请输入抽奖次数'
    }
    ])
  }
  !totalTimesChecked &&  validate.add(Number(dayTimes), [ {
    condition: 'isIntervalRight',
    max: 99,
    min: 1,
    errMsg: '抽奖次数请设置1~99之间',
  }, {
    condition: 'isInteger',
    errMsg: `抽奖次数必须为整数`
  }]);

  if (!dayTimesChecked && String(totalTimes) == "") {
    validate.add(totalTimes, [{
      condition: 'isAlert',
      errMsg: '请输入抽奖次数'
    }
    ])
  }
  !dayTimesChecked && validate.add(Number(totalTimes), [{
    condition: 'isIntervalRight',
    max: 99,
    min: 1,
    errMsg: '抽奖次数请设置1~99之间',
  }, {
    condition: 'isInteger',
    errMsg: `抽奖次数必须为整数`
    }]);

}

function validateBargainType(validate: any) {
  const { count, canPay } = storeState;
  const {
    prizeNum,         // 奖品数量
    minPrice,         // 底价
    maxPrice,         // 日常价
    minCutPrice,      // 最少砍价
    maxCutPrice,      // 最多砍价
    intervalTime      // 砍价间隔时间
  } = storeState.bargainParameter;

  // 特殊情况可以输入为0的底价
  validate.add(maxPrice-minPrice, [{
    condition: 'isNonNegative',
    errMsg: '日常价必须大于底价'
  }]);

  validate.add(count, [{
    condition: 'isIntervalRight',
    max: 200,
    min: 2,
    errMsg: '砍价次数必须为【2-200】的正整数',
  }]);
}

function validataSolitaireType(validate: any) {
  const {
    canPay,
    payNumber,
    limitNum,
    solitaireList,
    mainTextColor
  } = storeState;
  const currentPrice = solitaireList[solitaireList.length - 1].price;
  const currentSize = solitaireList[solitaireList.length - 1].size;

  canPay  && validate.add(Number(currentPrice) - Number(payNumber), [{
    condition: 'isNonNegative',
    errMsg: '定金价格不能高于接龙价格'
  }]);

  validate.add(Number(limitNum) - Number(currentSize), [{
    condition: 'isNonNegative',
    errMsg: `上限人数必须大于等于最高接龙人数`
  }]);

  validateCondition.add('isDecrement', function(value: number, errMsg: string) : string | void {
    if (value <= 0) {
      return errMsg;
    }
  });
  const len = solitaireList.length;
  let count = 0;
  let flag = 0;
  let currentPriceTemp = 0;
  let prevPriceTemp = 0;

  for (let i = 0; i < len; i++) {
    const rencentSolitaire = solitaireList[i - 1];
    const { size, price } = solitaireList[i];
    if (i > 0 && Number(solitaireList[i - 1].price) - Number(price) > 300) {
      count++;
      flag = i;
      currentPriceTemp = Number(price);
      prevPriceTemp = Number(solitaireList[i - 1].price);
    }

    rencentSolitaire && validate.add(Number(size) - Number(rencentSolitaire.size), [{
      condition: 'isDecrement',
      errMsg: '接龙人数应该递增'
    }]);

    rencentSolitaire && validate.add(Number(rencentSolitaire.price) - Number(price), [{
      condition: 'isDecrement',
      errMsg: '接龙价应该递减'
    }]);
  }

  validateCondition.add('isDecrement', function(value: number, errMsg: string) : string | void {
    if (value <= 0) {
      return errMsg;
    }
  });
  if (count && !window.hasValidated) {
    const errMsg = count===1 ? `当前第${flag},${flag+1}梯度间价格差>300元。<span style="color: ${mainTextColor}">为避免无效用户报名，建议相邻梯度价格差额<=300</span>` : `当前存在多组阶梯间价格差>300元。<span style="color: ${mainTextColor}">为避免无效用户报名，建相邻梯度价格差额<=300</span>`;
    Vue.$confirm({
      oneBtn: true,
      title: "提示",
      text: errMsg,
      okText: "我知道了"
    });
    window.hasValidated = true;
  }
}
// 团购的表单校验
function validateGroupType(validate: any) {
  const {
    section,
    payType,         // 支付类型
    canPay,          // 是否开启了支付
    payNumber,       // 支付金额
    ladderGroupList  // 阶梯拼团方案
  } = storeState;
  const {
    originPrice,  // 日常价
    personNumber, // 成团人数
    groupNumber,   // 成团数
    courseGroupList, // 课程列表
  } = section;
  canPay &&
    payType === '定金' &&
    validate.add(payNumber, [
      {
        condition: 'isNonEmpty',
        errMsg: '请输入支付金额'
      }
    ]);
  for (let i = 0; i < courseGroupList.length; i++){
    validate.add(courseGroupList[i].courseName, [
      {
        condition: 'isNonEmpty',
        errMsg: '课程名称不能为空'
      }
    ]);
    const currentPrice = courseGroupList[i].ladderGroupList[ladderGroupList.length - 1].groupPrice;
    canPay && payType === '定金' && validate.add(Number(currentPrice) - Number(payNumber), [{
      condition: 'isNonNegative',
      errMsg: '定金价格不能高于拼团价格'
    }]);

    // 检验阶梯拼团方案是否正确
  validateCondition.add('isDecrement', function(value: number, errMsg: string) : string | void {
    if (value <= 0) {
      return errMsg;
    }
  });
  const len = courseGroupList[i].ladderGroupList.length;
  for (let j = 0; j < len; j++) {
    const rencentLadder = courseGroupList[i].ladderGroupList[j - 1];
    const { groupSize, groupPrice } = courseGroupList[i].ladderGroupList[j];
    rencentLadder && validate.add(Number(groupSize) - Number(rencentLadder.groupSize), [{
      condition: 'isDecrement',
      errMsg: '拼团人数应该递增'
    }]);

    rencentLadder && validate.add(Number(rencentLadder.groupPrice) - Number(groupPrice), [{
      condition: 'isDecrement',
      errMsg: '拼团价应该递减'
    }]);

    validate.add(courseGroupList[i].originPrice - Number(groupPrice), [
      {
        condition: 'isNonNegative',
        errMsg: `拼团价应该小于日常价`
      }
    ]);
  }
  }
}
// ai招生的表单校验
function validateAIEnroll(validate: any) {
  const { distributeTypeParameter, section, activityIntros } = storeState;
  const { hasCheckUserAgreement } = distributeTypeParameter;
  validate.add(activityIntros, [
    {
      condition: 'isNonEmpty',
      errMsg: '活动说明不能为空'
    }
  ]);
  validate.add(hasCheckUserAgreement, [{
    condition: 'isNonEmpty',
    errMsg: '请先阅读并同意用户协议&免责声明'
  }]);
}
